import React, { useEffect, useRef } from 'react';
import { Spin, Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { type AppDispatch } from '../../../redux/store';
import {
  getUnapprovedSalePaymentsAction,
  updateUnsettledSalePaymentsAction,
} from '../../Sales/store/salesActions';

interface SalePayment {
  saleNumber: string | undefined;
  cashier: string;
  transactionDate: string;
  description: string;
  notes?: string;
  branch?: any;
  paymentType: string;
  _id: string;
  principal: number | undefined;
  OtherTransaction?: {
    Amount: number;
    Description: string;
  };
  extra: number;
}

export default function SalePaymentsApprovalIndex(): JSX.Element {
  const dispatch = useDispatch<AppDispatch>();

  const { unapprovedPayments }: any = useSelector<any>((state) => state?.sales);

  const processingRef = useRef(false);
  const getSalePayments = async (): Promise<void> => {
    await getUnapprovedSalePaymentsAction(dispatch, {});
    processingRef.current = false;
  };

  useEffect(() => {
    void getSalePayments();
  }, []);

  const handleUpdate = async (salePayment: SalePayment, status: string) => {
    try {
      await updateUnsettledSalePaymentsAction(dispatch, {
        id: salePayment._id,
        status,
      });
      void getSalePayments();
    } catch (error) {
      console.error('Error updating payment:', error);
      processingRef.current = false;
    } finally {
      processingRef.current = false;
    }
  };

  const columns = [
    {
      title: 'S.No',
      dataIndex: 'sno',
      render: (_: any, record: SalePayment, index: number) => index + 1,
      width: 50,
    },
    {
      title: 'Branch',
      dataIndex: 'branch',
      key: 'branch',
      render: (_: any, record: SalePayment) => (
        <p>{record.branch?.name}</p>
      ),
    },
    {
      title: 'Sale Number',
      dataIndex: 'saleNumber',
      key: 'saleNumber',
      render: (_: any, record: SalePayment) => <p>{record.saleNumber}</p>,
    },
    {
      title: 'Principal',
      dataIndex: 'principal',
      key: 'principal',
      render: (_: any, record: SalePayment) => <p>{record.principal}</p>,
    },
    {
      title: 'Extra',
      dataIndex: 'extra',
      key: 'extra',
      render: (_: any, record: SalePayment) => (
        <p>{record.extra}</p>
      ),
    },
    {
      title: 'Cash received',
      dataIndex: 'actions',
      width: 200,
      render: (_: any, record: SalePayment) => (
        <button
          className="search__button"
          style={{
            background: !processingRef.current ? '#27ae60' : '#b2b2b2',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            padding: '8px 24px',
            fontWeight: 700,
            cursor: !processingRef.current ? 'pointer' : 'not-allowed',
            opacity: !processingRef.current ? 1 : 0.7,
          }}
          disabled={processingRef.current}
          onClick={() => {
            if (!processingRef.current) {
              processingRef.current = true;
              void handleUpdate(record, 'cash_settlement');
            }
          }}
        >
          Cash received
        </button>
      ),
    },
    {
      title: 'Reject',
      dataIndex: 'actions2',
      width: 200,
      render: (_: any, record: SalePayment) => (
        <button
          className="search__button"
          style={{
            background: !processingRef.current ? '#e74c3c' : '#b2b2b2',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            padding: '8px 24px',
            fontWeight: 700,
            cursor: !processingRef.current ? 'pointer' : 'not-allowed',
            opacity: !processingRef.current ? 1 : 0.7,
          }}
          disabled={processingRef.current}
          onClick={() => {
            if (!processingRef.current) {
              processingRef.current = true;
              void handleUpdate(record, 'rejected');
            }
          }}
        >
          Reject
        </button>
      ),
    },
  ];

  return (
    <div className="users__table__page">
      {!(unapprovedPayments.length > 0) && <Spin spinning={false} fullscreen />}
      <div style={{ width: '100%' }}>
        <Table dataSource={unapprovedPayments} columns={columns} />
      </div>
    </div>
  );
}
